// eslint-disable-next-line import/no-unresolved
import { Navbar as MicroNavbar, NavbarProps } from 'navbar/components';
import { isAdvisorMode } from '../environment';

const showProps: NavbarProps['show'] = { notifications: false };

export const Navbar = () => {
  if (isAdvisorMode) {
    return <MicroNavbar show={showProps} />;
  }

  return <MicroNavbar />;
};
